const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
export default ClassNameGenerator;


// WEBPACK FOOTER //
// ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js